import { ChatState, Sessions } from "./types";
import { CHAT_STATE, MAX_SESSION_AGE } from "./constants";
import { MutableRefObject } from "react";
import { t } from 'i18next';

/**
 * Returns the active chat session_id for a given sessionKey at call time.
 * Prefer the useChatSessionId() hook which derives sessionKey from AppContext.
 */
export const getSessionId = (sessionKey: string): string | undefined => {
  const id = getChatState(sessionKey)?.sessions?.[sessionKey]?.session_id;
  return id || undefined;
};

export const getChatState = (sessionKey: string) => {
  const defaultChatState = {
    isOpen: false,
    sessions: {
      [sessionKey]: {
        session_id: '',
        timestamp: 0,
      },
    },
  }
  return JSON.parse(sessionStorage.getItem(CHAT_STATE) ?? JSON.stringify(defaultChatState));
}

export const submitButtonLabel = () => {
  if (typeof globalThis === 'undefined') return;
  const labelKey = getComputedStyle(document.documentElement)
    .getPropertyValue('--theme-chat-submit-button-label-key')
    .trim();
  return t(labelKey || 'ask');
};

export const deleteOldSessions = (sessions: Sessions) => {
  const now = Date.now();
  Object.entries(sessions).forEach(([sessionKey, session]) => {
    if (now - session.timestamp > MAX_SESSION_AGE) {
      delete sessions[sessionKey];
    }
  });
}

export const closeOpenReference = (sessionKey: string) => {
  sessionStorage.setItem(CHAT_STATE, JSON.stringify({
    ...getChatState(sessionKey),
    isOpen: false,
  }));
}

export const updateChatState = (state: MutableRefObject<ChatState>, sessionKey: string) => {
  const defaultChatState = {
    isOpen: false,
    sessions: {
      [sessionKey]: {
        session_id: '',
        timestamp: 0,
      },
    },
  }
  state.current = JSON.parse(sessionStorage.getItem(CHAT_STATE) ?? JSON.stringify(defaultChatState));
}
